var _a;
import { __assign } from "tslib";
import React from 'react';
import styles from './invoiceTagView.module.less';
import { OutlinedGeneralOutPrivate } from '@hose/eui-icons';
import { get } from 'lodash';
export var TagType;
(function (TagType) {
    TagType["TAX_BLACKLIST"] = "taxBlacklist";
})(TagType || (TagType = {}));
var TAG_COLOR_MAP = (_a = {},
    _a[TagType.TAX_BLACKLIST] = {
        backgroundColor: 'var(--eui-function-danger-50, #FDCDC5)',
        color: 'var(--eui-function-danger-600, #CB272D)',
    },
    _a);
export var getTagColorConfig = function (type) {
    return TAG_COLOR_MAP[type];
};
var TaxBlacklist = function (_a) {
    var style = _a.style, master = _a.master, _b = _a.isShow, isShow = _b === void 0 ? false : _b;
    var colorConfig = getTagColorConfig(TagType.TAX_BLACKLIST);
    if (!master) {
        return null;
    }
    if (isShow !== true) {
        var isTaxBlacklist = get(master, "form.E_" + (master === null || master === void 0 ? void 0 : master.entityId) + "_\u9500\u65B9\u9ED1\u540D\u5355", '否');
        if (isTaxBlacklist !== '是') {
            return null;
        }
    }
    return (React.createElement("span", { className: "" + styles.tag_base, style: __assign({ backgroundColor: colorConfig.backgroundColor, color: colorConfig.color }, style) },
        React.createElement(OutlinedGeneralOutPrivate, null),
        React.createElement("span", null, i18n.get('税局黑名单'))));
};
export { TaxBlacklist, TAG_COLOR_MAP };
